import { parseString } from './helpers'

export interface VersionInterface {
  version: string | null
  url: string | null
}

export function parseVersionModel(versionResponse: VersionInterface): VersionInterface {
  return {
    version: parseString(versionResponse?.version, null),
    url: parseString(versionResponse?.url, null),
  }
}
